import { humanId } from 'human-id';
export default function getRandomHumanId() {
  return humanId({
    capitalize: false,
    separator: '-'
  });
}